import {useSelector} from 'react-redux';

import {selectUserData} from '~/shared/store/storeModules/user';

const useIsGovUser = (): boolean => {
  const user = useSelector(selectUserData);

  return !!user?.isGovCompany;
};

export default useIsGovUser;
